import { Action, applyMiddleware, createStore, Store } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import thunkMiddleware from "redux-thunk";

import { IAppReduxState } from "../common/types/app";
import { NODE_ENV } from "../config/env";
import reducer from "./rootReducer";
import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();

const middlewares =
  NODE_ENV === "production"
    ? applyMiddleware(sagaMiddleware, thunkMiddleware)
    : composeWithDevTools(applyMiddleware(sagaMiddleware, thunkMiddleware));

const store: Store<IAppReduxState, Action> = createStore(reducer, middlewares);

sagaMiddleware.run(rootSaga);

export default store;
